// you will be able to (as of 1.8.6 Angular Ui-Router) get Angular compiled menu with ajax-compile attribute (works for ajax-url)
// please make sure bind-html-compile is injected into main app

(function() {
  'use strict';

  var xmsDropdown = function ($sce, $timeout, $compile, ajaxCall, errorMsgFactory) {
    return {
        restrict: 'A',
        replace: false,
        scope: true,
        bindToController: {
            ajaxUrl:"@"
        },
        controllerAs: 'ctrl',
        controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){

            var _this = this;


            $scope.menuOpen = false;

            this.getMenu = function(event) {
                console.log('dropdown getMenu');
                // open menu
                $scope.menuOpen = true;
                // show ajax loader in there
                if( angular.isDefined(_this.ajaxUrl) ){
                    $scope.innerMenu = $sce.trustAsHtml('<li><a><i class="loading-spinner gray-bg" style="margin-bottom:0;">Please wait...</i></a></li>');
                    _this.getInnerMenu(_this.ajaxUrl); // getMenu
                }

                event.stopPropagation()
                event.preventDefault();
            };

            this.getInnerMenu = function(url, data) {
                // ajax call
                console.log('dropdown getInnerMenu');

                ajaxCall.getData(url, data).then(
                    function(result) {
                        $scope.innerMenu = $sce.trustAsHtml(result.data);

                        // fix for Recent menu - being closed with bind-html-compile immediately after load
                        if($scope.menuOpen){
                            $timeout(function(){
                                $scope.menuOpen = true;
                            });
                        }
                    },
                    function(result) {
                        $scope.innerMenu = $sce.trustAsHtml( errorMsgFactory.connectionErrorDropdown(result) );
                    }
                );
            }

        }],
        require: 'xmsDropdown',
        // transclude: true,
        compile: function( tElement, tAttributes ) {

            // store the content of the directive in the variable then remove it
            var htmlContent = tElement.html();
            tElement.html(''); // remove

            return {
                pre: function preLink(scope, elem, attrs, ctrl) {
                    var timer;

                    elem.bind("click", function(event){
                        // (*) hence we need clear it here
                        event.stopPropagation();
                        $timeout.cancel(timer);

                        if( scope.innerMenu !== undefined ) {
                            // open menu only if it's not empty
                            scope.$apply(function() {
                                scope.menuOpen = true;
                            });
                        }
                    });

                    // Best Practice: Directives should clean up after themselves. You can use elem.on('$destroy', ...) or scope.$on('$destroy', ...) to run a clean-up function when the directive is removed.
                    elem.on('$destroy', function() {
                        $timeout.cancel(timer);
                    });
                },
                post: function postLink(scope, elem, attrs, ctrl) {


                    (function initialize(){

                        var $html = $('<div />',{ html:htmlContent }); // for easier manipulation
                        var isAjaxDropdown = angular.isDefined(ctrl.ajaxUrl) ? true : false;

                        // apply Angular UI Dropdown
                        var triggerEl = $html.find('[xms-dropdown-toggle]');
                        if(!triggerEl.length) {
                            throw 'xms-dropdown-toggle not found!';
                        }
                        triggerEl.attr('uib-dropdown-toggle','')
                               .attr('tabindex','0');
                        var triggerId = triggerEl.attr('id');
                        if(isAjaxDropdown){
                            triggerEl.attr('ng-click', "ctrl.getMenu($event)");
                        }


                        var menu   = $html.find('[xms-dropdown-menu]');
                        var isMenu = menu.length,
                            $menu  = menu;
                        if(!isMenu) {
                            if(!isAjaxDropdown) {
                                throw 'xms-dropdown-menu not found!';
                            }
                            $menu = $('<ul />');
                        }
                        if(isAjaxDropdown){
                            // you can now get Angular compiled menu with ajax-compile attribute (works for ajax-url)
                            // var bindHtml = typeof attrs.ajaxCompile !== 'undefined' ? 'bind-html-compile' : 'ng-bind-html';
                            // var bindHtml = 'ng-bind-html'; // for now // TODO: for Angular Ui-Router
                            $menu.attr('bind-html-compile', 'innerMenu');
                        }
                        $menu.attr('uib-dropdown-menu','')
                             .attr('aria-labelledby', triggerId)
                             .attr('role', 'menu');
                        if(!isMenu){
                            $html.append( $menu );
                        }


                        elem.attr('uib-dropdown','')
                            .attr('uib-keyboard-nav','')
                            .attr('is-open','menuOpen');

                        elem.append( $html.html() );

                        elem.removeAttr('xms-dropdown'); // otherwise it will compile in a loop
                        $compile(elem)(scope);
                        elem.attr('xms-dropdown',''); // re-add attr to not to lose information on tag
                    })(); // execute on init



                    $timeout(function(){
                        elem.parent().attr('data-angular-compile',''); // otherwise it doesn't work while compiling on reload...
                    });

                }
            }
        }
    };
  }

  xmsDropdown.$inject = ['$sce', '$timeout', '$compile', 'ajaxCall', 'errorMsgFactory'];
  angular.module('app').directive('xmsDropdown', xmsDropdown);


  var xmsDropdownToggle = function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, elem, attrs, ctrl, transclude) {

            $timeout(function(){
                if(angular.isDefined(attrs.focus) && attrs.focus=="true") {
                    elem.focus();
                    elem.removeAttr('focus');
                }
            });
        }
    }
  }
  xmsDropdownToggle.$inject = ['$timeout'];
  angular.module('app').directive('xmsDropdownToggle', xmsDropdownToggle);




/* Submenu */
// the directive is similar to xmsDropdown - maybe at some point they can be combined together with some params

  var _openSubmenus = new Array(); // kind of mini-pseudo factory


  var subDropdown = function ($timeout, $compile, $sce, ajaxCall, errorMsgFactory) {
    return {
        restrict: 'A',
        replace: false,
        scope: true,
        bindToController: {
            ajaxUrl:"@"
        },
        controllerAs: 'ctrl',
        controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){

            var _this = this;

            $scope.menuOpen = false;
            this.submenuIndex = (_openSubmenus.push($scope.menuOpen) - 1);

            this.getMenu = function(event) {
                console.log('subDropdown getMenu');
                // open menu
                $scope.menuOpen = !$scope.menuOpen;

                if($scope.menuOpen && !angular.isDefined($scope.innerSubMenu) ) {
                    // show ajax loader in there
                    if( angular.isDefined(_this.ajaxUrl) ){
                        $scope.innerSubMenu = $sce.trustAsHtml('<li><a><i class="loading-spinner gray-bg" style="margin-bottom:0">Please wait...</i></a></li>');
                        _this.getInnerMenu(_this.ajaxUrl); // getMenu
                    }
                }

                event.stopPropagation()
                event.preventDefault();
            };

            this.getInnerMenu = function(url, data) {
                ajaxCall.getData(url, data).then(
                    function(result) {
                        $scope.innerSubMenu = $sce.trustAsHtml(result.data);
                    },
                    function(result) {
                        $scope.innerSubMenu = $sce.trustAsHtml( errorMsgFactory.connectionErrorDropdown(result) );
                    }
                );
            }


            /* communication between submenus */
            /* only one submenu open at the time (closing the rest) */
            $scope.$watch('menuOpen', function(newVal,oldVal){
                if(newVal!=oldVal){
                    if($scope.menuOpen){
                        // open Submenus array update
                        angular.forEach(_openSubmenus, function(val, index){
                            _openSubmenus[index] = false; // close all
                        });
                        _openSubmenus[_this.submenuIndex] = true;
                    }
                }
            });
            $scope.$watch(
                function(){
                    return _openSubmenus[_this.submenuIndex];
                }, function(newVal, oldVal){
                    if(newVal!=oldVal && !newVal){
                        $scope.menuOpen = false;
                    }
                }
            );

        }],
        require:'subDropdown',
        compile: function( tElement, tAttributes ) {

            // store the content of the directive in the variable then remove it
            var htmlContent = tElement.html();
            tElement.html(''); // remove

            return function postLink(scope, elem, attrs, ctrl) {

                (function initialize(){

                    var $html = $('<div />',{ html:htmlContent }); // for easier manipulation
                    var isAjaxDropdown = angular.isDefined(ctrl.ajaxUrl) ? true : false;


                    var triggerEl = $html.find('[sub-dropdown-toggle]');
                    if(!triggerEl.length) {
                        throw 'sub-dropdown-toggle not found!';
                    }
                    if(isAjaxDropdown){
                        triggerEl.attr('ng-click', "ctrl.getMenu($event); $event.stopPropagation();");
                    } else {
                        triggerEl.attr('ng-click','menuOpen=!menuOpen; $event.stopPropagation();');
                    }


                    var menu   = $html.find('[sub-dropdown-menu]');
                    var isMenu = menu.length,
                        $menu  = menu;

                    if(!isMenu) {
                        if(!isAjaxDropdown) {
                            throw 'sub-dropdown-menu not found!';
                        }
                        $menu = $('<ul />');
                    }

                    if(isAjaxDropdown){
                        $menu.attr('ng-bind-html', 'innerSubMenu');
                    }

                    $menu.attr('uib-collapse','!menuOpen')
                        .attr('role', 'menu')
                        // .attr('ng-if','menuOpen') // otherwise the keyboard navigates through hidden submenu elements
                        // .attr('aria-hidden','{{!menuOpen}}'); // aria-hidden won't fix the above problem
                        .addClass('dropdown-menu')
                        .addClass('dropdown-submenu');

                    if(!isMenu){
                        $html.append( $menu );
                    }


                    elem.attr('ng-class','{show:menuOpen}')
                        .addClass('submenu clearfix');

                    elem.append( $html.html() );

                    elem.removeAttr('sub-dropdown');
                    $compile(elem)(scope);
                    elem.attr('sub-dropdown',''); // re-add attr to not to lose information on tag

                })(); // execute on init

            }
        }
    }
  }
  subDropdown.$inject = ['$timeout', '$compile', '$sce', 'ajaxCall', 'errorMsgFactory'];
  angular.module('app').directive('subDropdown', subDropdown);


  var subDropdownToggle = function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, elem, attrs, ctrl, transclude) {
            elem.addClass('submenu-toggle')
                .attr('role', 'button')
                .append('<span class="icon-el icon-el-xs icon-el-s-ieoverride icon-arrow-down"></span>')
                .append('<span class="icon-el icon-el-xs icon-el-s-ieoverride icon-arrow-up"></span>');
        }
    }
  }
  subDropdownToggle.$inject = ['$timeout'];
  angular.module('app').directive('subDropdownToggle', subDropdownToggle);



}());
